<template>
  <form v-loading="loading" @submit.prevent="create">
    <b-modal
      ref="modal"
      :visible="true"
      :title="
        $t('Create object', { object: this.$tc('Accounts', 1).toLowerCase() })
      "
      @hide="close"
    >
      <div class="form-group">
        <label>{{ $t("Name") }}</label>
        <input
          v-model="model.name"
          :minlength="3"
          type="text"
          class="form-control"
          required
        />
      </div>
      <div class="form-group">
        <label>{{ $t("Billable Plan") }}</label>
        <select v-model="model.billable_plan_id" class="form-control">
          <option
            v-for="(plan, planKey) in customPlans"
            :key="planKey"
            :value="plan.id"
          >
            {{ plan.name }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <input
          id="account-create-form-enabled"
          v-model="model.enabled"
          type="checkbox"
        />
        <label for="account-create-form-enabled">{{ $t("Active") }}?</label>
      </div>
      <template slot="modal-footer">
        <button type="submit" class="btn btn-primary">
          {{ $t("Create") }}
        </button>
        <button type="button" class="btn btn-secondary" @click.prevent="close">
          {{ $t("Close") }}
        </button>
      </template>
    </b-modal>
  </form>
</template>

<script>
import AccountModel from "../models/AccountModel";
import AccountService from "../services/AccountsService";
import ApiService from "../services/ApiService";
export default {
  name: "AppPageAccountsCreate",
  data() {
    return {
      model: AccountModel.getDefaults(),
      loading: false,
      customPlans: [],
    };
  },
  mounted() {
    this.getPlans();
  },
  methods: {
    getPlans() {
      ApiService.request("GET", "billing/plans", {
        is_default: 0
      })
        .then((response) => {
          if (response.status === 200) {
            this.customPlans = response.data;
          } else {
            console.log("error");
          }
        })
        .catch(() => {
          console.log("error");
        });
    },
    create() {
      this.loading = true;
      const data = AccountModel.toApiRequest(this.model);
      AccountService.create(data)
        .then(() => {
          this.$toastr.success(
            this.$t("Action", {
              object: this.$tc("Accounts", 1),
              action: this.$t("created"),
            }),
            this.$t("Success")
          );
          this.close();
        })
        .catch((error) => {
          this.$toastr.error(error.message, this.$t("Error"));
          this.loading = false;
        });
    },
    close() {
      this.$router.back();
    },
  },
};
</script>
